import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=383fadfe&scoped=true"
import script from "./Dialog.vue?vue&type=script&lang=ts"
export * from "./Dialog.vue?vue&type=script&lang=ts"
import style0 from "../style.scss?vue&type=style&index=0&id=383fadfe&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383fadfe",
  null
  
)

export default component.exports